import React from 'react';
import { Link, Theme, Typography } from '@material-ui/core';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import {
  ProcessingDialog,
  ProcessingDialogState,
} from '@bizapp-frontend/customer/organisms/ProcessingDialog';
import { Link as RouterLink } from 'react-router-dom';

const useStyle = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    headingBox: {
      padding: theme.spacing(6, 0, 3),
      textAlign: 'center',
      '& .MuiTypography-h2': {
        marginBottom: '27px',
        color: '#4285F4',
        fontSize: '24px',
        fontWeight: 'bold',
      },
      '& .MuiTypography-h3': {
        marginTop: theme.spacing(0),
        marginBottom: theme.spacing(2),
        fontSize: '20px',
        fontWeight: 'bold',
      },
      '& .MuiTypography-body1': {
        fontSize: '14px',
        '& span': { display: 'block' },
      },
      '& svg': {
        marginTop: theme.spacing(3),
        marginBottom: theme.spacing(3),
      },
    },
    headingTitleText: {
      fontSize: '14px',
      lineHeight: '21px',
      fontWeight: 'bold',
      color: '#333333',
    },
    headingDescriptionText: {
      margin: theme.spacing(3.5, 0, 5),
      fontSize: '14px',
      lineHeight: '21px',
      fontWeight: 'normal',
      color: '#333333',
      '& > p': {
        margin: theme.spacing(3.5, 0, 0),
      },
      '& a': {
        color: '#1565C0',
      },
    },
  }),
);

export interface RepurchaseApplicationStep3Props {
  className?: string;
  dialogState?: ProcessingDialogState;
  onClickDialogClose?: () => void;
}

export const RepurchaseApplicationStep3: React.FC<RepurchaseApplicationStep3Props> = ({
  className,
  children,
  dialogState,
  onClickDialogClose,
}) => {
  const classes = useStyle();
  return (
    <div className={`${classes.root} ${className || ''}`}>
      <div className={classes.headingBox}>
        <Typography variant="h2">お支払いが完了しました</Typography>
        <div className={classes.headingDescriptionText}>
          <Typography>
            <span>引き続きのご利用をありがとうございます。</span>
            <span>今後ともよろしくお願いいたします。</span>
          </Typography>
          <Typography>
            <span>
              次回以降の請求においても、今回ご登録いただいたお支払い方法が適用されます。
            </span>
            <span>
              お支払い方法を変更される場合は、
              <Link component={RouterLink as any} to="/plan-contract">
                こちら
              </Link>
              からお手続きをお願いいたします。
            </span>
          </Typography>
        </div>
        {children}
      </div>
      <ProcessingDialog
        state={dialogState ?? 'close'}
        onClickError={onClickDialogClose}
      />
    </div>
  );
};
